import {
  Container,
  Spinner,
  Stack,
  Text,
  useBreakpointValue,
  useColorMode,
} from '@chakra-ui/react';
import * as React from 'react';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { colors } from '../Stitches';
import { fetchDraftForRecipient } from '../api/Drafts';
import { formatComposer } from '../data/routes';
import { Authenticated } from './AuthGuards';
import { useAuthenticateApiCall } from './hooks/useAuthenticateApiCall';

// NOTE: This is the same as the friendPicker container. If they keep changing together
// extract as a component.
const PreComposerContainer = (props: { children: React.ReactNode }) => {
  const { colorMode } = useColorMode();
  const boxShadow = useBreakpointValue([undefined, 'base']);
  return (
    <Container
      bg={colorMode === 'dark' ? colors.dark.whiteAlpha100 : 'white'}
      boxShadow={boxShadow}
      w="sm"
      p={8}
      rounded="xl"
    >
      {props.children}
    </Container>
  );
};

const usePreComposer = (recipient: string) => {
  const apiCall = useAuthenticateApiCall(fetchDraftForRecipient);
  const { data } = useQuery(['pre-composer', recipient], apiCall(recipient), { cacheTime: 0 });

  const navigate = useNavigate();

  useEffect(() => {
    if (data && data.id !== undefined) {
      navigate(formatComposer({ letterId: data.id }));
    }
  }, [data, navigate]);
};

const PreComposer = ({ friendId }: { friendId: string }) => {
  usePreComposer(friendId);

  return (
    <PreComposerContainer>
      <Stack spacing={4} direction="row">
        <Spinner />
        <Text>Getting your draft</Text>
      </Stack>
    </PreComposerContainer>
  );
};

type Params = { friendId: string };

export const AuthenticatedPreComposer = () => {
  const { friendId } = useParams<Params>() as Params;
  return (
    <Authenticated>
      <PreComposer friendId={friendId} />
    </Authenticated>
  );
};
